import App from '../App/app';

export default App;